import { Component, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { environment } from '../../../../../environments/environment.prod';
import { Property } from 'app/modules/admin/properties/property.model';
import { CoreConfigService } from '../../../../../@core/services/config.service';
import { LandingService } from '../landing.service';

declare var google: any;
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  map;
  inicio = { lat: 22.1338607, lng: -101.0142929 };
  url = environment.URL_AWS;
  properties: Property[] = [];
  constructor(
    private _currencyPipe: CurrencyPipe,
    private _coreConfigService: CoreConfigService,
    private _LandingService: LandingService
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  province = {
    name: 'San Luis Potosí',
    id: 1847
  };

  suburbs: any[] = [];
  suburbsBasic: any[] = [];
  provincesBasic: any[] = [];
  provinceLoading = false;

  ngOnInit(): void {
    this.getSuburbs(this.province);
    this.initMap();
  }

  getSuburbs(event): void {
    this.province.name = event.name;
    this._LandingService.getSuburbsById(event.id).then(
      (data: any) => {

        this.suburbsBasic = data;
        const todos = {
          id: 0,
          fullName: 'Todos',
        }
        this.suburbsBasic.unshift(todos);
        this.suburbs.push(data[3], data[7]);
      }, (error: any) => {
        console.log(error);
      }
    );
  }

  initMap() {


    this.map = new google.maps.Map(document.getElementById("map"), {
      center: this.inicio,
      zoom: 15,
      panControl: false,
      streetViewControl: false,
      scaleControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
    });

    const triangleCoords = [
      { lat: 22.135191, lng: -101.019749 },
      { lat: 22.139332753772173, lng: -101.00688790095282 },
      { lat: 22.138792443001222, lng: -101.0067020186324 },
      { lat: 22.128561544928093, lng: -101.01944698512376 },
      { lat: 22.135191, lng: -101.019749 },
    ];

    // Construct the polygon.
    const bermudaTriangle = new google.maps.Polygon({
      paths: triangleCoords,
      strokeColor: "#1A7DB6",
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: "#0D426E",
      fillOpacity: 0.3,
    });

    bermudaTriangle.setMap(this.map);

    const triangleCoords1 = [
      { lat: 22.128584409866374, lng: -101.01946150222933 },
      { lat: 22.135079765972186, lng: -101.0108367374078 },
      { lat: 22.133042722885175, lng: -101.00890843632982 },
      { lat: 22.12614541264609, lng: -101.01796357326475 },
      { lat: 22.128584409866374, lng: -101.01946150222933 },
    ];

    // Construct the polygon.
    const bermudaTriangle1 = new google.maps.Polygon({
      paths: triangleCoords1,
      strokeColor: "#fd7356",
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: "#ff5733",
      fillOpacity: 0.3,
    });

    bermudaTriangle1.setMap(this.map);

    const triangleCoords2 = [
      { lat: 22.140111112159058, lng: -101.01760556872276 },
      { lat: 22.140244817921193, lng: -101.01396074588278 },
      { lat: 22.137186266850946, lng: -101.01387052749565 },
      { lat: 22.136517722251632, lng: -101.01625229291584 },
      { lat: 22.140111112159058, lng: -101.01760556872276 },
    ];

    // Construct the polygon.
    const bermudaTriangle2 = new google.maps.Polygon({
      paths: triangleCoords2,
      strokeColor: "#4EF4FD",
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: "#0EEBF8",
      fillOpacity: 0.3,
    });

    bermudaTriangle2.setMap(this.map);

    this.map.addListener("center_changed", () => {

      console.log(JSON.parse(JSON.stringify(this.map.getBounds())));

    });



    this.properties.forEach((element) => {

      const contentString = `
      <div class="card" style="width: 18rem;">
        <img src="${this.url + element.propertyImages[0].path}" class="card-img-top" alt="...">
        <div class="card-body">
        <h6 class="card-title">${element.title}</h6>
          <h5 class="card-title"><small class="text-muted">${this._currencyPipe.transform(element.price)}</small></h5>
          <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
          <a href="#" class="btn btn-primary" (click)="verDetalles(${element.id})" >Ver detalles</a>
        </div>
      </div>
      `;

      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        ariaLabel: "Uluru",
      });


      const marker = new google.maps.Marker({
        position: { lat: Number(element.latitude), lng: Number(element.longitude) },
        map: this.map,
      });

      marker.addListener("click", () => {
        infowindow.open({
          anchor: marker,
          map: this.map,
        });
      });

    });


  }

}
